import { Record } from 'immutable';
export default Record({
  vid: null,
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  phoneExtension: '',
  jobtitle: ''
}, 'QuoteContact');